import {

    EDITAR_PACIENTE,
    EDITAR_PACIENTE_EXITO,
    EDITAR_PACIENTE_ERROR,
    MOSTRAR_ALERTA

} from '../types';

import clienteAxios
    from '../config/axios';

import {
    cargarPacientesAction
} from './cargarPacientesActions';


/*
========================================
EDITAR PACIENTE ADMINISTRATIVO
========================================

IMPORTANTE:

Por ahora mantenemos el comportamiento
histórico del sistema:

1. Se modifica el campo.
2. Backend confirma el cambio.
3. Volvemos a cargar lista_pacientes.

Más adelante podremos optimizar el GET,
pero primero migramos la ficha sin cambiar
la lógica de sincronización existente.
*/

export function editarPacienteAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        dispatch(
            editarPaciente()
        );


        try {

            const {
                config,
                payload
            } = informacion;


            const respuesta =
                await clienteAxios.post(

                    '/paciente/editarpacienteadministrativo',

                    payload,

                    config

                );


            dispatch(
                editarPacienteExito(
                    respuesta.data.msg
                )
            );


            /*
            Volvemos a cargar los pacientes
            para que Redux tenga exactamente
            el estado confirmado por backend.
            */

            await dispatch(
                cargarPacientesAction({
                    config
                })
            );


            /*
            El componente necesita saber
            que el guardado terminó bien
            antes de cerrar el modo edición.
            */

            return {

                ok: true,

                data:
                    respuesta.data

            };


        } catch (
            error
        ) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudo editar el paciente'
                };


            dispatch(
                editarPacienteError(
                    mensaje
                )
            );


            dispatch(
                setearAlertaError(
                    mensaje
                )
            );


            /*
            También devolvemos el error.

            De esta forma DatosPaciente puede
            mantener abierto el campo que se
            estaba editando.
            */

            return {

                ok: false,

                error:
                    mensaje

            };

        }

    };

}


const editarPaciente = () => ({

    type:
        EDITAR_PACIENTE,

    payload:
        true

});


const editarPacienteExito = (
    msg
) => ({

    type:
        EDITAR_PACIENTE_EXITO,

    payload:
        msg

});


const editarPacienteError = (
    msg
) => ({

    type:
        EDITAR_PACIENTE_ERROR,

    payload:
        msg

});


const setearAlertaError = (
    msg
) => ({

    type:
        MOSTRAR_ALERTA,

    payload:
        msg

});